import {EventEmitter, Injectable, Output} from '@angular/core';
import {MesswertPaket} from '../../model/messwerte/messwert-paket';
import {VorhersageHeute, VorhersageTag, VorhersageZehnTage} from '../../model/vorhersagen/vorhersage-zehn-tage';
import {environment} from '../../../environments/environment';
import {VorhersageMesswerte} from '../../model/vorhersagen/vorhersage-messwerte';

@Injectable({
  providedIn: 'root'
})
export class DatastoreService {

  vorhersagen24hHeute: Array<VorhersageHeute>;
  vorhersagen24hZehnTage: Array<VorhersageZehnTage>;
  vorhersagen3hZehnTage: Array<VorhersageZehnTage>;
  messwertList: Array<MesswertPaket> = [];

  public onDataChange: EventEmitter<any> = new EventEmitter<any>();

  public onRefreshVorhersagen: EventEmitter<any> = new EventEmitter<any>();

  private iconUrl = `${environment.storageBasePath}${environment.firebaseConfig.storageBucket}/wetter/icons/tagesschau/TSicons_`;

  public saveMesswertPakete(messwertPakete: MesswertPaket[]): void {
    this.messwertList = messwertPakete;
  }

  public mapDataTo3hZehnTageVorhersagen(data) {
    if (this.vorhersagen3hZehnTage === undefined || this.vorhersagen3hZehnTage === null) {
      this.vorhersagen3hZehnTage = [];
    }
    this.vorhersagen3hZehnTage = data.map(d => Object.assign(new VorhersageZehnTage(), d as VorhersageZehnTage));
    this.vorhersagen3hZehnTage.forEach(vorhersage => vorhersage.getTagesListe().forEach(tag => this.copyDreiStundenWerte(tag)));
  }

  public mapDataTo24hZehnTageVorhersagen(data) {
    if (this.vorhersagen24hZehnTage === undefined || this.vorhersagen24hZehnTage === null) {
      this.vorhersagen24hZehnTage = [];
    }
    this.vorhersagen24hZehnTage = data.map(d => Object.assign(new VorhersageZehnTage(), d as VorhersageZehnTage));
    this.vorhersagen24hZehnTage.forEach(vorhersage => vorhersage.getTagesListe().forEach(tag => this.copWerteGanzerTag(tag)));
    this.onDataChange.emit(this.vorhersagen24hZehnTage);
  }

  public mapDataTo24hHeuteVorhersagen(data, emitChanges: boolean = true) {
    if (this.vorhersagen24hHeute === undefined || this.vorhersagen24hHeute === null) {
      this.vorhersagen24hHeute = [];
    }
    this.vorhersagen24hHeute = data.map(d => Object.assign(new VorhersageHeute(), d as VorhersageHeute)).filter(value => value.ort.name !== 'unnamed');
    this.vorhersagen24hHeute.forEach(vorhersage => this.copWerteGanzerTag(vorhersage.tag00));
    if (emitChanges) {
      this.onDataChange.emit(this.vorhersagen24hHeute);
    }
    return this.vorhersagen24hHeute;
  }

  public emitChanges(changeObj) {
    this.onDataChange.emit(changeObj);
  }

  // Der Ursprungswert wird in ein "richtiges" Feld kopiert
  private copWerteGanzerTag(tag: VorhersageTag) {
    if (tag !== undefined && tag !== null) {
      tag.werteGanzerTag = Object.assign(new VorhersageMesswerte(), tag['00:00-00:00'] as VorhersageMesswerte);
      tag['00:00-00:00'] = null;
    }
  }

  private copyDreiStundenWerte(tag: VorhersageTag) {
    tag.werteListeDreiStunden = new Array<VorhersageMesswerte>();
    let tage: VorhersageMesswerte[] = [tag['00:00-03:00'], tag['03:00-06:00'], tag['06:00-09:00'], tag['09:00-12:00'], tag['12:00-15:00'], tag['15:00-18:00'], tag['18:00-21:00'], tag['21:00-00:00']];
    tage.forEach(t => tag.werteListeDreiStunden.push(Object.assign(new VorhersageMesswerte(), t)));
    tage.forEach(t => t = null);

    // Hier muss nochmal gefiltert werden
    tag.werteListeDreiStunden = tag.werteListeDreiStunden.filter(wert => wert !== null && wert !== undefined && wert.gueltigVonUTC !== null && wert.gueltigVonUTC !== undefined);
  }

  public get24hVorhersagenHeuteByGlobalIds(GLOBAL_IDS: string[]): Array<VorhersageHeute> {
    if (this.vorhersagen24hHeute !== undefined) {
      return this.vorhersagen24hHeute.filter(vorhersage => GLOBAL_IDS.includes(vorhersage.ort.id));
    }
  }

  public getWetterSymbolUrl(wert: number) {
    return wert !== null && wert !== undefined ? `${this.iconUrl}${wert.toLocaleString(undefined, {minimumIntegerDigits: 2})}.png` : '';
  }
}
